import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.StatementEmailTemplate.List.IRequest;
type Response = Api.Core.StatementEmailTemplate.List.IResponse;
type Headers = Api.Core.StatementEmailTemplate.List.IHeaders;
const url = '/api/Management/StatementEmailTemplate';
export default async function statementEmailTemplateListApi(body?: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url,
    body,
    headers: getDefaultHeaders(),
  });
}
